export const defaultScreenTimeInSeconds = 20;
export const defaultScreenTimeInMs = defaultScreenTimeInSeconds * 1000;

export const OVERLAY_UNACTIVE_TIMEOUT = 3000; // in miliseconds

export const ZOOM_SCREEN_DEFAULT_STAY_IN_DETAIL_TIME = 3; // in seconds
export const ZOOM_SCREEN_DEFAULT_SEQ_DELAY_TIME = 2; // in seconds
